var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item,staticClass:"md-collapse"},[_c('div',{staticClass:"md-collapse-label"},[_c('p',{staticClass:"py-0"},[_vm._v(" "+_vm._s(item)+" ")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }